module.exports = __webpack_public_path__ + "img/logout.0ac88bf5.svg";